import {html, nothing} from '@isceco/widget-library2/external/lit'
import {when} from '@isceco/widget-library2/external/lit/directives/when';
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/Card/Card'
import '@isceco/widget-library2/basic-elements/Checkbox/Checkbox.js'
import '@isceco/widget-library2/basic-elements/DateInput/DateInput.js'
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea'
import '@isceco/widget-library2/basic-elements/Title/Title'
import LanguageSwitcher from '@isceco/widget-library2/basic-elements/LanguageSwitcher/LanguageSwitcher'
import '../../../../components/Collapsible/Collapsible'
import '../../../../components/RadioGroupVertical/RadioGroupVertical'
import BeschwerdeformularService from './BeschwerdeformularService'
import LandService from '../../../../services/LandService'
import KantonService from '../../../../services/KantonService'
import BeschreibungDTO from '../../../Monitoring/BeschreibungDTO'
import FormComponent from "../../../../components/FormComponent";
import BeschwerdeFormularCss from './BeschwerdeformularCss';

export default class Beschwerdeformular extends FormComponent {
  static BUTTON_NEXT_TEXT = 'form.button.next'
  static BUTTON_BACK_TEXT = 'form.button.back'
  static RADIO_JA_TEXT = 'form.radiobutton.ja'
  static RADIO_NEIN_TEXT = 'form.radiobutton.nein'
  static BUTTON_WIDTH = '160px'
  static PHONE_PATTERN_INTL_CH = '^(?:0[0-9]{2}\\s*[0-9]{3}\\s*[0-9]{2}\\s*[0-9]{2}|0[0-9]{3}\\s*[0-9]{3}\\s*[0-9]{3}|(?:00|\\+)[0-9]{2}\\s*[0-9]{2,5}\\s*[0-9]{2,12})$';

  eingereichtVon = ''
  artDerBeschwerde = ''
  artDerTelefonnummer = 'BITTE_AUSWAEHLEN'
  anderswoBeschwert = ''
  anderepraktikenChecked = false
  confirmed = false;
  landItems = [];
  eingereichtVonLandName = ''
  beschwerdeGegenLandName = ''

  lands = [];
  kantons = [];

  get translationFile() {
    return './views/WBF/SECO/Beschwerdeformular/i18n.json'
  }

  async connectedCallback() {
    super.connectedCallback()
    await new LandService().list().then(lands => {
      if (lands) {
        this.lands = lands;
        this.landItems = lands.map(land => ({
          value: land.code,
          name: new BeschreibungDTO(land.beschreibung).text
        }))
      }
    })
    await new KantonService().list().then(kantone => {
      if (kantone) {
        this.kantons = kantone;
        this.kantonItems = kantone.map(kanton => ({
          value: kanton.code,
          name: new BeschreibungDTO(kanton.beschreibung).text
        }))
      }
    })
    document.addEventListener(LanguageSwitcher.EVENT_KEYS.LANGUAGE_CHANGED, () => {
      this.landItems = this.lands.map(land => ({
        value: land.code,
        name: new BeschreibungDTO(land.beschreibung).text
      }))
      this.kantonItems = this.kantons.map(kanton => ({
        value: kanton.code,
        name: new BeschreibungDTO(kanton.beschreibung).text
      }))
    })
    this.reload()
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(LanguageSwitcher.EVENT_KEYS.LANGUAGE_CHANGED);
  }

  get css() {
    return [BeschwerdeFormularCss]
  }

  renderStartSection = () => {
    return html`
      <eform-collapsible id="start"
                         open="true"
                         ?preview="${this.preview}"
                         summary="${this.i18n.translate('beschwerdeformular.step.start')}">
        <isceco-card text="${this.i18n.translate('beschwerdeformular.startseite.paragraph1.title')}" class="form-card">
          <span
            style="margin-top: var(--isceco-space-100); font-weight: bold">${this.i18n.translate('beschwerdeformular.startseite.paragraph1.subtitle1')}</span>
          <p style="margin-top: var(--isceco-space-100)">
            ${this.i18n.translate('beschwerdeformular.startseite.paragraph1.text1')}</p>
          <span
            style="font-weight: bold">${this.i18n.translate('beschwerdeformular.startseite.paragraph1.subtitle2')}</span>
          <p style="margin-top: var(--isceco-space-100)">
            ${this.i18n.translate('beschwerdeformular.startseite.paragraph1.text2')}</p>
        </isceco-card>
        <isceco-card text="${this.i18n.translate('beschwerdeformular.startseite.paragraph2.title')}" class="form-card">
          <p style="margin-top: var(--isceco-space-100); white-space: pre-line"><span
            style="font-weight: bold">${this.i18n.translate('beschwerdeformular.startseite.paragraph2.subtitle1')}</span>
            ${this.i18n.translate('beschwerdeformular.startseite.paragraph2.text1')}</p>
        </isceco-card>
        ${!this.preview ? html`
          <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
            <div style="text-align: left; padding-left: 1rem">
              <isceco-checkbox
                label="${this.i18n.translate('beschwerdeformular.startseite.confirm.checkbox')}"
                @change="${e => {
                  this.confirmed = e.detail?.value;
                  this.render()
                }}"
                .readonly="${this.preview}"
              ></isceco-checkbox>
            </div>
            <div style="text-align: right">
              <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_NEXT_TEXT)}"
                             id="start-next"
                             @click="${() => this._openCard('artDerBeschwerde')}"
                             width="${Beschwerdeformular.BUTTON_WIDTH}"
                             variant="primary"
                             .disabled="${!this.confirmed}"
              ></isceco-button>
            </div>
          </div>
        ` : html``}
      </eform-collapsible>
    `
  }

  renderArtDerBeschwerdeSection = () => {
    return html`
      <eform-collapsible id="artDerBeschwerde"
                         ?preview="${this.preview}"
                         summary="${this.i18n.translate('beschwerdeformular.step.auswahl')}">
        <isceco-card class="form-card">
          <isceco-radio-group-vertical
            name="artDerBeschwerde"
            style="margin-top: -2rem"
            .items="${[{
              value: 'WERBEANRUF',
              name: this.i18n.translate('beschwerdeformular.artderbeschwerde.paragraph1.radiobutton1')
            },
              {
                value: 'ANDERE_GESCHAEFTSPRAKTIKEN',
                name: this.i18n.translate('beschwerdeformular.artderbeschwerde.paragraph1.radiobutton2')
              }]}"
            @change="${e => {
              this.artDerBeschwerde = e.detail?.value
              this.render()
            }}"
            .readonly="${this.preview}"
            required
          ></isceco-radio-group-vertical>
          <p>${this.i18n.translate('beschwerdeformular.artderbeschwerde.paragraph1.text1')}</p>
        </isceco-card>
        ${!this.preview ? html`
          <div style="display:flex;">
            <div style="display:flex; gap: 8px; margin-left: auto;">
              <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_BACK_TEXT)}"
                             @click="${() => this._openCard('start')}"
                             width="${Beschwerdeformular.BUTTON_WIDTH}" variant="secondary"></isceco-button>
              <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_NEXT_TEXT)}"
                             @click="${() => this._openCard('beschwerdeEingereichtVon')}"
                             width="${Beschwerdeformular.BUTTON_WIDTH}" variant="primary"></isceco-button>
            </div>
          </div>
        ` : html``}
      </eform-collapsible>
    `
  }

  renderBeschwerdeEingereichtVonSection = () => {
    const titleTelekomOderWebseite = this.artDerBeschwerde === 'WERBEANRUF' ?
      this.i18n.translate('beschwerdeformular.field.telekomAnbieter') :
      this.i18n.translate('beschwerdeformular.field.web')
    return html`
      <eform-collapsible id="beschwerdeEingereichtVon"
                         ?preview="${this.preview}"
                         summary="${this.i18n.translate('beschwerdeformular.step.von')}">
        <isceco-card class="form-card">
          <isceco-radio-group
            name="eingereichtVon.beschwerdeEingereichtVonAuswahl"
            style="--form-align: 12rem; margin-top: -2rem"
            label="${this.i18n.translate('beschwerdeformular.beschwerdeiengereichtvon.auswahl.title')}"
            value="NATUERLICHE_PERSON"
            .items="${[{
              value: 'NATUERLICHE_PERSON',
              name: this.i18n.translate('beschwerdeformular.beschwerdeiengereichtvon.auswahl.radiobutton2')
            },
              {
                value: 'FIRMA',
                name: this.i18n.translate('beschwerdeformular.beschwerdeiengereichtvon.auswahl.radiobutton1')
              }]}"
            @change="${e => {
              this.eingereichtVon = e.detail?.value
              this.render()
            }}"
            .readonly="${this.preview}"
            required
            inline
          ></isceco-radio-group>
          ${this.eingereichtVon === 'FIRMA' ? html`
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.firmaorg')}*"
                               name="eingereichtVon.firma"
                               .readonly="${this.preview}"
                               required
            ></isceco-text-input>
          ` : ''}
          <div class="single-line">
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.vorname.required')}"
                               name="eingereichtVon.vorname"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               required
            ></isceco-text-input>
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.nachname.required')}"
                               name="eingereichtVon.nachname"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               required
            ></isceco-text-input>
          </div>
          <div class="single-line">
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.strasse')}*"
                               name="eingereichtVon.strasse"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               required
            ></isceco-text-input>
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.hausnummer')}*"
                               name="eingereichtVon.hausnummer"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               help-text="${this.i18n.translate('beschwerdeformular.field.hausnummer.info')}"
                               required
            ></isceco-text-input>
          </div>
          <div class="two-col">
            <div class="col">
              <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.postfach')}"
                                 name="eingereichtVon.postfach"
                                 .readonly="${this.preview}"
              ></isceco-text-input>
            </div>
            <div class="col"></div>
          </div>
          <div class="single-line">
            <isceco-number-input label="${this.i18n.translate('beschwerdeformular.field.plz')}*"
                                 name="eingereichtVon.plz"
                                 min="1000"
                                 max="99999"
                                 maximum-fraction-digits="0"
                                 .readonly="${this.preview}"
                                 style="width: 100%"
                                 required
            ></isceco-number-input>
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.ort')}*"
                               name="eingereichtVon.ort"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               required
            ></isceco-text-input>
          </div>
          <div class="two-col">
            <div class="col">
              <isceco-dropdown label="${this.i18n.translate('beschwerdeformular.field.land')}*"
                               name="eingereichtVon.land"
                               .items="${this.landItems}"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               required
                               @change="${this._onEingereichtVonLandChange}"
              ></isceco-dropdown>
            </div>
            <div class="col">
              ${when(this.eingereichtVonLandCode === 'CHE', () => html`
                <isceco-dropdown label="${this.i18n.translate('beschwerdeformular.field.kanton')}*"
                                 name="eingereichtVon.kanton"
                                 .items="${this.kantonItems}"
                                 .readonly="${this.preview}"
                                 style="width: 100%"
                                 required
                                 @change="${this._onEingereichtVonKantonChange}"
                ></isceco-dropdown>
              `)}
            </div>
          </div>
          <div class="single-line">
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.telefon.required')}"
                               name="eingereichtVon.telefon"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               pattern="${Beschwerdeformular.PHONE_PATTERN_INTL_CH}"
                               pattern-error-text="${this.i18n.translate('beschwerdeformular.field.telefon.errormessage')}"
                               required
            ></isceco-text-input>
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.fax')}"
                               name="eingereichtVon.fax"
                               .readonly="${this.preview}"
                               style="width: 100%"
            ></isceco-text-input>
          </div>
          <div class="single-line">
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.email')}*"
                               type="email"
                               name="eingereichtVon.email"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               pattern-error-text="${this.i18n.translate('beschwerdeformular.field.email.error')}"
                               required
            ></isceco-text-input>
            <isceco-text-input label="${titleTelekomOderWebseite}"
                               name="eingereichtVon.telekomAnbieter"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               required
            ></isceco-text-input>
          </div>
        </isceco-card>
        ${!this.preview ? html`
          <div style="display:flex;">
            <div style="display:flex; gap: 8px; margin-left: auto;">
              <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_BACK_TEXT)}"
                             @click="${() => this._openCard('artDerBeschwerde')}"
                             width="${Beschwerdeformular.BUTTON_WIDTH}" variant="secondary"></isceco-button>
              <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_NEXT_TEXT)}"
                             @click="${() => this._openPage4or6()}"
                             width="${Beschwerdeformular.BUTTON_WIDTH}" variant="primary"></isceco-button>
            </div>
          </div>
        ` : html``}
      </eform-collapsible>
    `
  }

  renderUnerbetenenWerbeanrufen = () => {
    return html`
      <!-- content for 1 -->
      <isceco-card class="form-card">
        <isceco-radio-group-vertical
          name="unerbetenenWerbeanrufen.rufnummerImTelefonVerzeichnis"
          style="--radio-group-label-font-weight: bold; --form-align: 25rem; margin-top: -2rem;"
          label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl1.title')}"
          .items="${[{
            value: 'NICHT_IM_TELEFONVERZEICHNIS',
            name: this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl1.radiobutton1')
          },
            {
              value: 'IM_TELEFONVERZEICHNIS',
              name: this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl1.radiobutton2')
            }]}"
          .readonly="${this.preview}"
          required
          inline
        ></isceco-radio-group-vertical>
        <p><span
          style="font-weight: bold">${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl1.hinweis.title')}</span>
          ${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl1.hinweis.text')}
        </p>
        <p style="margin-bottom: unset">
          <span
            style="font-weight: bold">${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.text')}</span>
          <br>
          <span
            style="font-size: small">${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.text.info')}</span>
        </p>
        <isceco-dropdown
          name="unerbetenenWerbeanrufen.artDerTelefonnummer"
          label=${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.title')}
          .value="${this.artDerTelefonnummer}"
          @change="${({detail: {value: v}}) => {
            this.artDerTelefonnummer = (v == null || v === '' ? 'BITTE_AUSWAEHLEN' : v);
            this.render()
          }}"
          .readonly="${this.preview}"
          .items="${[
            {
              value: 'BITTE_AUSWAEHLEN',
              name: `${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.placeholder')}`
            },
            {
              value: 'FESTZNETZNUMMER',
              name: `${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.option1')}`
            },
            {
              value: 'MOBILETELEFONNUMMER',
              name: `${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.option2')}`
            },
            {
              value: 'LOCALE_NUMMERN',
              name: `${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.option3')}`
            },
            {
              value: 'AUSLAENDISCHE_NUMMER',
              name: `${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.option4')}`
            },
            {
              value: 'NICHT_ZUTEILBARE_NUMMERS',
              name: `${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.artdertelefonnumer.dropdown.option5')}`
            }]}"
        ></isceco-dropdown>
        ${this._renderCorrespondingNummer()}
        <isceco-text-input
          label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.evtlfirma')}"
          name="unerbetenenWerbeanrufen.evtlFirma"
          .readonly="${this.preview}"
        ></isceco-text-input>
        <isceco-text-input
          label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.addresse')}"
          name="unerbetenenWerbeanrufen.evtlAdresse"
          .readonly="${this.preview}"
        ></isceco-text-input>
        <div class="single-line">
          <isceco-date-input
            label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.datum')}"
            name="unerbetenenWerbeanrufen.datumDesAnrufs"
            .readonly="${this.preview}"
            style="width: 100%"
            type="datetime-local"
            max="${new Date().toLocaleString('sv-SE').slice(0, 16).replace(' ', 'T')}"
            required
          ></isceco-date-input>
        </div>
        <isceco-radio-group
          name="unerbetenenWerbeanrufen.anrufVonMirEntgegengenommen"
          style="--form-align: 25rem"
          label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl2.title')}"
          .items="${[{value: 'JA', name: this.i18n.translate(Beschwerdeformular.RADIO_JA_TEXT)},
            {value: 'NEIN', name: this.i18n.translate(Beschwerdeformular.RADIO_NEIN_TEXT)}]}"
          .readonly="${this.preview}"
          required
          inline
        ></isceco-radio-group>
        <isceco-radio-group
          name="unerbetenenWerbeanrufen.anrufBetrafKrankenkasse"
          style="--form-align: 25rem"
          label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl3.title')}"
          .items="${[{value: 'JA', name: this.i18n.translate(Beschwerdeformular.RADIO_JA_TEXT)},
            {value: 'NEIN', name: this.i18n.translate(Beschwerdeformular.RADIO_NEIN_TEXT)},
            {value: 'WEISS_NICHT', name: this.i18n.translate('form.radiobutton.weissnicht')}]}"
          .readonly="${this.preview}"
          required
          inline
        ></isceco-radio-group>
        <isceco-textarea
          label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.kommentar')}"
          placeholder="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.kommentar.placeholder')}"
          name="unerbetenenWerbeanrufen.kommentar"
          rows="2"
          resize="manual"
          maxlength="10000"
          .readonly="${this.preview}"
        ></isceco-textarea>
        <p><b>${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.auswahl4.title')}</b></p>
        <isceco-radio-group
          name="unerbetenenWerbeanrufen.ermaechtigung"
          style="--radio-group-label-font-weight: bold; --form-align: 25rem; margin-top: -1.5rem"
          .items="${[{value: 'JA', name: this.i18n.translate(Beschwerdeformular.RADIO_JA_TEXT)},
            {value: 'NEIN', name: this.i18n.translate(Beschwerdeformular.RADIO_NEIN_TEXT)}]}"
          .readonly="${this.preview}"
          required
          inline
        ></isceco-radio-group>
      </isceco-card>
      <isceco-card
        text="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.paragraph2.subtitle')}"
        class="form-card">
        <span>${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.paragraph2.text')}</span>
        <isceco-file-input label="${this.i18n.translate('beschwerdeformular.field.anhaenge')}"
                           name="unerbetenenWerbeanrufen.attachments"
                           multiple
                           maxfiles="5"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

      <div style="display:flex;">
        <div style="display:flex; gap: 8px; margin-left: auto;">
          <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_BACK_TEXT)}"
                         @click="${() => this._openCard('beschwerdeEingereichtVon')}"
                         width="${Beschwerdeformular.BUTTON_WIDTH}" variant="secondary"></isceco-button>
        </div>
      </div>
    `
  }

  renderBeschwerdeGegen = () => {
    const titleTelekomOderWebseite = this.artDerBeschwerde === 'WERBEANRUF' ?
      this.i18n.translate('beschwerdeformular.field.telekomAnbieter') :
      this.i18n.translate('beschwerdeformular.field.web')
    return html`
      <!-- content for 2 -->
      <isceco-card class="form-card">
        <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.firma.required')}"
                           name="beschwerdeGegen.firma"
                           .readonly="${this.preview}"
                           required
        ></isceco-text-input>
        <div class="single-line">
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.vorname')}"
                             name="beschwerdeGegen.vorname"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.nachname')}"
                             name="beschwerdeGegen.nachname"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
        </div>
        <div class="single-line">
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.strasse')}"
                             name="beschwerdeGegen.strasse"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.hausnummer')}"
                             name="beschwerdeGegen.hausnummer"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
        </div>
        <div class="two-col">
          <div class="col">
            <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.postfach')}"
                               name="beschwerdeGegen.postfach"
                               .readonly="${this.preview}"
            ></isceco-text-input>
          </div>
          <div class="col"></div>
        </div>
        <div class="single-line">
          <isceco-number-input label="${this.i18n.translate('beschwerdeformular.field.plz')}"
                               name="beschwerdeGegen.plz"
                               min="1000"
                               max="9999"
                               maximum-fraction-digits="0"
                               .readonly="${this.preview}"
                               style="width: 100%"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.ort')}"
                             name="beschwerdeGegen.ort"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
        </div>
        <div class="two-col">
          <div class="col">
            <isceco-dropdown label="${this.i18n.translate('beschwerdeformular.field.land')}"
                             name="beschwerdeGegen.land"
                             .items="${this.landItems}"
                             .readonly="${this.preview}"
                             style="width: 100%"
                             @change="${this._onBeschwerdeGegenLandChange}"
            ></isceco-dropdown>
          </div>
          <div class="col">
            ${when(this.beschwerdeGegenLandCode === 'CHE', () => html`
              <isceco-dropdown label="${this.i18n.translate('beschwerdeformular.field.kanton')}"
                               name="beschwerdeGegen.kanton"
                               .items="${this.kantonItems}"
                               .readonly="${this.preview}"
                               style="width: 100%"
                               @change="${this._onBeschwerdeGegenKantonChange}"
              ></isceco-dropdown>
            `)}
          </div>
        </div>
        <div class="single-line">
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.telefon')}"
                             name="beschwerdeGegen.telefon"
                             pattern="${Beschwerdeformular.PHONE_PATTERN_INTL_CH}"
                             pattern-error-text="${this.i18n.translate('beschwerdeformular.field.telefon.errormessage')}"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.fax')}"
                             name="beschwerdeGegen.fax"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
        </div>
        <div class="single-line">
          <isceco-text-input label="${this.i18n.translate('beschwerdeformular.field.email')}"
                             type="email"
                             name="beschwerdeGegen.email"
                             .readonly="${this.preview}"
                             pattern-error-text="${this.i18n.translate('beschwerdeformular.field.email.error')}"
                             style="width: 100%"
          ></isceco-text-input>
          <isceco-text-input label="${titleTelekomOderWebseite}"
                             name="beschwerdeGegen.webseite"
                             .readonly="${this.preview}"
                             style="width: 100%"
          ></isceco-text-input>
        </div>
      </isceco-card>
      ${!this.preview ? html`
        <div style="display:flex;">
          <div style="display:flex; gap: 8px; margin-left: auto;">
            <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_BACK_TEXT)}"
                           @click="${() => this._openCard('artDerBeschwerde')}"
                           width="${Beschwerdeformular.BUTTON_WIDTH}" variant="secondary"></isceco-button>
            <isceco-button text="${this.i18n.translate('form.button.next')}"
                           @click="${() => this._openCard('beanstandetegeschaeftspraktiken')}"
                           width="${Beschwerdeformular.BUTTON_WIDTH}" variant="primary"></isceco-button>
          </div>
        </div>
      ` : html``}
    `
  }

  renderPage4Or6Section = () => {
    return html`
      <eform-collapsible
        id="page4Or6"
        ?preview="${this.preview}"
        summary="${this.artDerBeschwerde === 'WERBEANRUF'
          ? this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.paragraph1.title')
          : this.i18n.translate('beschwerdeformular.beschwerderichtetsichgegen.titel')}"
      >
        ${when(
          this.artDerBeschwerde === 'WERBEANRUF',
          () => this.renderUnerbetenenWerbeanrufen(),
          () => this.renderBeschwerdeGegen()
        )}
      </eform-collapsible>
    `
  }

  renderBeanstandeteGeschaeftspraktikenSection = () => {
    return html`
      <eform-collapsible
        id="beanstandetegeschaeftspraktiken"
        ?preview="${this.preview}"
        summary="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.titel')}">
        <isceco-card class="form-card">
          <div class="checkbox-grid">
            <div class="checkbox-row">
              <isceco-checkbox
                name="geschaeftspraktiken.adressbuchschwindel"
                label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.adressbuchschwindel')}"
                .readonly="${this.preview}"
              ></isceco-checkbox>
            </div>
            <isceco-checkbox
              name="geschaeftspraktiken.irrefuehrung"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.irreführung')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.vorauszahlungsbetruegerei"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.vorauszahlungsbetrügerei')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.impressum"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.impressum')}"
              .readonly="${this.preview}"
              style="flex-grow: 0.33"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.spamming"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.spamming')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.lotterien"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.gewinnversprechen')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.aggressiveVerkaufsmethoden"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.aggressiveverkaufsmethoden')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.schneeballsysteme"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.schneeballsysteme')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.missbraeuchlicheKlausen"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.missbräuchliche')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.mogelpackungen"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.mogelpackungen')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.geoblocking"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.geoblocking')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.werbefahrtenWerbeveranstaltung"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.werbefahrten')}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
            <isceco-checkbox
              name="geschaeftspraktiken.anderePraktiken"
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.auswahl.anderepraktik')}"
              @change="${e => {
                this.anderepraktikenChecked = e.detail?.value
                this.render()
              }}"
              .readonly="${this.preview}"
            ></isceco-checkbox>
          </div>
          ${this._renderWelchePraktik()}
          <br>
          <isceco-textarea
            label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.field.beschwerdesachverahlt.text')}"
            placeholder="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.field.beschwerdesachverahlt.text.placeholder')}"
            name="geschaeftspraktiken.sachverhalt"
            rows="4"
            resize="manual"
            maxlength="10000"
            required
            .readonly="${this.preview}"
          ></isceco-textarea>
          <div style="display:flex; align-items:center;">
              <span style="white-space: nowrap; margin-right: var(--isceco-space-200); font-weight: normal;">
                <b>${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.anderswobeschwert')}</b>
              </span>
            <isceco-radio-group
              name="geschaeftspraktiken.anderswoBeschwert"
              .items="${[
                {value: 'JA', name: this.i18n.translate(Beschwerdeformular.RADIO_JA_TEXT)},
                {value: 'NEIN', name: this.i18n.translate(Beschwerdeformular.RADIO_NEIN_TEXT)}
              ]}"
              @change="${e => {
                this.anderswoBeschwert = e.detail?.value
                this.render()
              }}"
              .readonly="${this.preview}"
              required
              inline
              style="--form-align: 10rem"
            ></isceco-radio-group>
          </div>
          ${this._renderWennJa()}
        </isceco-card>
        <isceco-card text="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.beilagen')}"
                     class="form-card">
          <isceco-file-input label="${this.i18n.translate('beschwerdeformular.field.anhaenge')}"
                             name="geschaeftspraktiken.attachments"
                             multiple
                             maxfiles="5"
                             maxsize="${this.fileMaxSize}"
                             .fileInputService="${this.fileInputService}"
                             .disabled="${this.preview}"
          ></isceco-file-input>
        </isceco-card>
        <div style="display:flex;">
          <div style="display:flex; gap: 8px; margin-left: auto;">
            <isceco-button text="${this.i18n.translate(Beschwerdeformular.BUTTON_BACK_TEXT)}"
                           @click="${() => this._openPage4or6()}"
                           width="${Beschwerdeformular.BUTTON_WIDTH}" variant="secondary"></isceco-button>
          </div>
        </div>
      </eform-collapsible>
    `
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="beschwerde-form"
                   include-disabled>

        <div slot="buttons" style="display: flex; flex-direction: column; gap: var(--isceco-space-200);">
          ${this.requiresCaptcha && !this.isCaptchaReady() ? html`
            <div style="color: #666; font-size: 0.875rem; display: flex; align-items: center; gap: 0.5rem;">
              <span>⏳ Verifying security check...</span>
            </div>
          ` : ''}
          <div style="display: flex; gap: var(--isceco-space-200);">
            <isceco-button text="${this.i18n.translate(submitKey)}"
                           @click="${() => this._submit()}"
                           variant="primary"
                           .disabled="${!this.confirmed || !this.isCaptchaReady()}"
            ></isceco-button>
            <isceco-button text="${this.i18n.translate('form.button.abort')}"
                           @click="${() => this.abort()}"
                           variant="secondary"
                           .disabled="${!this.preview}"
            ></isceco-button>
          </div>
        </div>

        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>
      </isceco-form>
    `
  }


  getFormElements = () => {
    return html`
      ${this.renderCaptcha()}
      ${this.renderStartSection()}
      ${this.renderConfirmedSection()}
    `;
  };

  _openCard = async cardId => {
    this._closeAllCards();
    // Wait a bit for the close animation to complete
    await new Promise(resolve => setTimeout(resolve, 50));
    const next = document.getElementById(cardId);
    next?.openCard();
    next?.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  _openPage4or6 = () => {
    if (this.artDerBeschwerde) {
      this._openCard('page4Or6');
    }
  }

  _closeAllCards = () => ['start', 'artDerBeschwerde', 'beschwerdeEingereichtVon', 'beanstandetegeschaeftspraktiken', 'page4Or6'].forEach(id => {
    document.getElementById(id)?.closeCard();
  });

  _renderWennJa() {
    if (this.anderswoBeschwert !== 'JA') {
      return nothing
    }
    return html`
      <isceco-text-input
        label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.anderswobeschwert.wennja')}"
        name="geschaeftspraktiken.beschwertBei"
        .readonly="${this.preview}"
        required
      ></isceco-text-input>
    `;
  }

  _renderWelchePraktik() {
    if (this.anderepraktikenChecked) {
      return html`
        <div class="two-col">
          <div class="col">
            <isceco-text-input
              label="${this.i18n.translate('beschwerdeformular.beanstandetegeschaeftspraktiken.field.welche.text')}"
              name="geschaeftspraktiken.welchePraktik"
              required
              .readonly="${this.preview}"
            ></isceco-text-input>
          </div>
          <div class="col"></div>
        </div>
      `;
    }
    return nothing;
  }

  _renderCorrespondingNummer() {
    if (this.artDerTelefonnummer === 'BITTE_AUSWAEHLEN') {
      return nothing
    }
    return html`
      <isceco-text-input
        label="${this.i18n.translate('beschwerdeformular.beschwerdebeiunterbetenwerbanrufen.field.nummer.' + String(this.artDerTelefonnummer))} "
        name="unerbetenenWerbeanrufen.nummer"
        .readonly="${this.preview}"
        required
        pattern="${this.phonePattern}"
        pattern-error-text="${this.phonePatternError}"
      ></isceco-text-input>
    `;
  }

  renderConfirmedSection() {
    if (!this.confirmed) {
      return null;
    }

    return html`
      ${this.renderArtDerBeschwerdeSection()}
      ${this.renderBeschwerdeEingereichtVonSection()}
      ${this.renderBeschwerdeDetailsSection()}
    `;
  }

  renderBeschwerdeDetailsSection() {
    if (!this.artDerBeschwerde) {
      return null;
    }

    return html`
      ${this.renderPage4Or6Section()}
      ${this.renderAndereGeschaeftspraktikenSection()}
    `;
  }

  renderAndereGeschaeftspraktikenSection() {
    if (this.artDerBeschwerde !== 'ANDERE_GESCHAEFTSPRAKTIKEN') {
      return null;
    }

    return this.renderBeanstandeteGeschaeftspraktikenSection();
  }

  get phonePattern() {
    switch (this.artDerTelefonnummer) {
      case 'FESTZNETZNUMMER':
        return String.raw`^0\d{2}\s?\d{3}\s?\d{2}\s?\d{2}$`  // 0xx xxx xx xx
      case 'MOBILETELEFONNUMMER':
        return String.raw`^07\d\s?\d{3}\s?\d{2}\s?\d{2}$`   // 07x xxx xx xx
      case 'LOCALE_NUMMERN':
        return String.raw`^0\d{3}\s?\d{3}\s?\d{3}$`           // 0xxx xxx xxx
      case 'AUSLAENDISCHE_NUMMER':
        return String.raw`^00\d{2}\s?\d{2,5}\s?\d{2,12}$`    // 00XX (2-5 Nummern) (2-12 Nummern)
      case 'NICHT_ZUTEILBARE_NUMMERS':
        return '.*'                                      // anything allowed
      default:
        return nothing
    }
  }

  get phonePatternError() {
    switch (this.artDerTelefonnummer) {
      case 'FESTZNETZNUMMER':
        return 'Format: 0xx xxx xx xx'
      case 'MOBILETELEFONNUMMER':
        return 'Format: 07x xxx xx xx'
      case 'LOCALE_NUMMERN':
        return 'Format: 0xxx xxx xxx'
      case 'AUSLAENDISCHE_NUMMER':
        return `Format: 00XX (2-5 ${this.i18n.translate('nummern')}) (2-12 ${this.i18n.translate('nummern')})`
      case 'NICHT_ZUTEILBARE_NUMMERS':
        return nothing
      default:
        return nothing
    }
  }

  _submit = () => {
    for (const card of this.querySelectorAll('eform-collapsible')) {
      card.openCard();
    }

    scrollToTop()

    const form = document.getElementById('beschwerde-form')
    if (!form.validate()) {
      return
    }

    if (!this.preview) {
      this.preview = true
      this.render()
      return
    }

    const values = form.getValues()
    if (values.eingereichtVon) {
      values.eingereichtVon.landName = this.eingereichtVonLandName
      values.eingereichtVon.kantonName = this.eingereichtVonKantonName
    }
    if (values.beschwerdeGegen) {
      values.beschwerdeGegen.landName = this.beschwerdeGegenLandName
      values.beschwerdeGegen.kantonName = this.beschwerdeGegenKantonName
    }
    new BeschwerdeformularService().submit(values, form, this)
  }

  _onEingereichtVonLandChange = ({detail: {value: code}}) => {
    if (code !== 'CHE') {
      this.eingereichtVonKantonName = null
    }
    const landItem = this.landItems.find(item => item.value === code)
    this.eingereichtVonLandCode = code;
    this.eingereichtVonLandName = landItem?.name ?? ''
    this.render()
  }

  _onBeschwerdeGegenLandChange = ({detail: {value: code}}) => {
    if (code !== 'CHE') {
      this.beschwerdeGegenKantonName = null
    }
    const landItem = this.landItems.find(item => item.value === code)
    this.beschwerdeGegenLandCode = code;
    this.beschwerdeGegenLandName = landItem?.name ?? ''
    this.render()
  }

  _onEingereichtVonKantonChange = ({detail: {value: code}}) => {
    const kantonItem = this.kantonItems.find(item => item.value === code)
    this.eingereichtVonKantonName = kantonItem?.name ?? ''
  }

  _onBeschwerdeGegenKantonChange = ({detail: {value: code}}) => {
    const kantonItem = this.kantonItems.find(item => item.value === code)
    this.beschwerdeGegenKantonName = kantonItem?.name ?? ''
  }
}
customElements.define('eform-frontend-wbf-seco-beschwerdeformular', Beschwerdeformular)
